import { render, staticRenderFns } from "./Crm.vue?vue&type=template&id=1521458b&scoped=true"
import script from "./Crm.vue?vue&type=script&lang=js"
export * from "./Crm.vue?vue&type=script&lang=js"
import style0 from "./Crm.vue?vue&type=style&index=0&id=1521458b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1521458b",
  null
  
)

export default component.exports